"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getFolderMruConfigurationService_1 = require("../services/getFolderMruConfigurationService");
var store_1 = require("../store/store");
var folderNameToId_1 = require("owa-session-store/lib/utils/folderNameToId");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Action to get Move to Mru list
 */
exports.default = legacy_1.action('getMoveToMruList')(function getMoveToMruList() {
    getFolderMruConfigurationService_1.default().then(function (response) { return processResponse(response); });
});
// Process TargetFolderMruConfiguration
function processResponse(response) {
    if (response.FolderMruEntries == null || response.FolderMruEntries.length == 0) {
        store_1.default.mruFolders.push(folderNameToId_1.default('inbox'));
        store_1.default.mruFolders.push(folderNameToId_1.default('deleteditems'));
        store_1.default.mruFolders.push(folderNameToId_1.default('archive'));
    }
    else {
        for (var i = 0; i < response.FolderMruEntries.length; i++) {
            var folderId = response.FolderMruEntries[i].EwsFolderIdEntry;
            store_1.default.mruFolders.push(folderId);
        }
    }
    store_1.default.isInitialized = true;
}
//# sourceMappingURL=getMoveToMruList.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-move-mru/lib/actions/getMoveToMruList.js
// module id = 1841
// module chunks = 23 62 105 108